module.exports = __webpack_public_path__ + "static/Sara-9acb19866b2750e7b70ab637fc352286.png";